module.exports = __webpack_public_path__ + "icomoon.42683.woff";